import React from 'react';
import { Box, Heading } from '@razorpay/blade/components';
import { TdsFilingDataList } from './TdsFilingDataList';

export const TdsFilingDashboard: React.FC = () => {
  return (
    <Box padding="spacing.6">
      <Heading size="large" marginBottom="spacing.6">
        TDS Filing Dashboard
      </Heading>
      <TdsFilingDataList />
    </Box>
  );
};

export default TdsFilingDashboard;
